export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-queue/index.js
// module id = ../../../../d3-queue/index.js
// module chunks = 4